export const reviews = [
    {
        id: 1,
        customerName: "Sarah M.",
        description: "We had our kitchen remodeled and the whole process was smoother than we expected. The team was professional, communicative, and the finished work looks amazing."
    },
    {
        id: 2,
        customerName: "James R.",
        description: "They replaced our flooring and did some interior painting for us. Everything was done on time, and the attention to detail really stood out."
    },
    {
        id: 3,
        customerName: "Melissa T.",
        description: "Very happy with the bathroom renovation. They were easy to work with, showed up when they said they would, and the final result turned out beautiful."
    },
    {
        id: 4,
        customerName: "David L.",
        description: "We hired them for drywall repair and trim work after some water damage. The repairs blended in perfectly and the space looks brand new again."
    },
    {
        id: 5,
        customerName: "Sarah P.",
        description: "Great experience from start to finish. They helped us update our deck and a few exterior details, and everything came out clean, solid, and well built."
    }
];





export const portfolioProjects = [
    {
        id: 1,
        title: "Custom Bunk Beds",
        location: "Washington",
        description: "Built custom bunk beds with integrated shelving, clean trim details, and a durable finish designed to maximize sleeping space while keeping the room functional and organized.",
        imageUrl: "project-images/1.jpg"
    },
    {
        id: 2,
        title: "Two-Story Deck Build",
        location: "Washington",
        description: "Constructed a large two-story deck system with new stairs, lower access, and modern black railing for a strong, clean look that adds both outdoor living space and value to the home.",
        imageUrl: "project-images/3.jpg"
    },
    {
        id: 3,
        title: "Covered Patio Structure",
        location: "Washington",
        description: "Built a freestanding covered patio with exposed framing and a warm wood finish to create a sheltered outdoor space that works great for relaxing, gathering, and year-round use.",
        imageUrl: "project-images/4.png"
    },
    {
        id: 4,
        title: "Front Entry Porch",
        location: "Washington",
        description: "Upgraded this front entry with a new porch, fresh steps, and matching railings to improve curb appeal while creating a safer and more welcoming entrance.",
        imageUrl: "project-images/5.jpg"
    },
    {
        id: 5,
        title: "Lower Deck and Stair Access",
        location: "Washington",
        description: "Added a lower deck beneath the main structure with wide steps and clean composite-style finishes to improve backyard access and create more usable outdoor space.",
        imageUrl: "project-images/7.jpg"
    },
    {
        id: 6,
        title: "Hot Tub Platform Deck",
        location: "Washington",
        description: "Built a custom platform deck for a hot tub installation with a clean wraparound finish and strong framing support designed for both durability and appearance.",
        imageUrl: "project-images/8.jpg"
    },
    {
        id: 7,
        title: "Privacy Fence Installation",
        location: "Washington",
        description: "Installed a new cedar privacy fence and gate with a simple decorative arbor detail for added security, privacy, and a clean finished look around the yard.",
        imageUrl: "project-images/10.jpg"
    },
    {
        id: 8,
        title: "Storage Shed Build",
        location: "Washington",
        description: "Constructed a custom storage shed with double doors, wood siding, and a metal roof to provide durable, functional storage with a clean finished appearance.",
        imageUrl: "project-images/11.jpg"
    },
    {
        id: 9,
        title: "Cable Rail Deck Detail",
        location: "Washington",
        description: "Finished this deck with composite decking, wood framing, and wire panel railing for a modern look that keeps the view open while maintaining safety.",
        imageUrl: "project-images/12.jpg"
    },
    {
        id: 10,
        title: "Wood Shelter Structure",
        location: "Washington",
        description: "Built a sturdy outdoor shelter structure with open sides, angled bracing, and a practical roofline, designed for storage, coverage, and long-term durability.",
        imageUrl: "project-images/14.jpg"
    },
    {
        id: 11,
        title: "Deck Skirting and Enclosure",
        location: "Washington",
        description: "Added custom wood skirting and enclosure work beneath the exterior deck to create a cleaner finish while protecting the under-deck area.",
        imageUrl: "project-images/15.jpg"
    },
    {
        id: 12,
        title: "Custom Dog Houses",
        location: "Washington",
        description: "Built matching custom dog houses with durable siding, framed openings, and metal roofing to create a practical and well-finished shelter for outdoor use.",
        imageUrl: "project-images/16.JPG"
    }
];